var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMicroOff = function SvgIconMicroOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(-324.000000, -841.000000) translate(324.000000, 841.763994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.472,
    height: 52.472,
    rx: 26.236
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FB355D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .003L22 22.003M8 8.003v3c.001 1.213.732 2.305 1.852 2.77 1.12.463 2.41.207 3.268-.65m.88-4.78v-5.34C14.002 1.462 12.835.17 11.301.015 9.768-.14 8.367.893 8.06 2.403",
    transform: "translate(-324.000000, -841.000000) translate(324.000000, 841.763994) translate(15.000000, 14.236006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.953c-1.997 2.039-5.032 2.66-7.67 1.572S3.98 13.857 4 11.003v-2m14 0v2c0 .413-.037.824-.11 1.23M11 18.003L11 22.003M7 22.003L15 22.003",
    transform: "translate(-324.000000, -841.000000) translate(324.000000, 841.763994) translate(15.000000, 14.236006)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicroOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-micro-off.77396e624dbd20c80ed07aee54868321.svg";